/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import NewTaskAction from './NewTaskAction/index'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Header"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let boardBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'board_icon_id',
})
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let aggregateData = fromHelpers.boardIcon(boardBoardIconIdValueData, tabSelectedBoardIdValueData)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let boardNameValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'name',
})
let tabSelectedBoardIdValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let aggregateData1 = fromHelpers.boardName(boardNameValueData, tabSelectedBoardIdValueData1)
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z2wmEtq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z2wmEtq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Header.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 iconHeight={24}
 iconWidth={24}
 data="board.board_icon_id"
 data="tab.selected.board_id"
 aggregate="helpers.js boardIcon"
 iconId={aggregateData}
/>
<div
  data-testid="Header.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pl-1-Z2wmEtq': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="board.name"
 data="tab.selected.board_id"
 aggregate="helpers.js boardName"
 text={aggregateData1}
/>
</div>
</div>
<NewTaskAction
  viewPath={`${viewPath}/NewTaskAction`}
/>
</div>
{children}
</React.Fragment>)
}